import React from 'react';

import EstimatedPrices from '../components/EstimatedPrices';
import PotentialBuyers from '../components/PotentialBuyers';
import ExpertMeeting from '../components/ExpertMeeting';
import PriceGraph from '../components/PriceGraph';
import SoldProperties from '../components/SoldProperties';
import NextSteps from '../components/NextSteps';
import HosmanPros from '../components/HosmanPros';
import HiddenPrices from '../components/HiddenPrices';
import TrustpilotReviews from '../../../../../shared/components/TrustpilotReviews';
import { defineFineProperty } from '../../../../../shared/utils/helpers/hosmanVars';

import { Separator } from 'hosman-material';

const classicSale = ({ sale, valuation, setValuation }) => {
  if (!valuation) return null;

  const isFineProperty = defineFineProperty(sale.region.name_raw === 'Paris', valuation.sale_price);
  const bigDiffWithExpectation = sale.price_expectations >= valuation.upper_price * 1.05;
  const confident = valuation.confidence >= 20;
  const showPrices = !sale.selling || (!isFineProperty && !bigDiffWithExpectation && confident);

  return (
    <div data-testid='classicSale'>
      {showPrices &&
        <div className='flex flex-col justify-center items-center md:px-10 md:flex-row gap-6 md:gap-10'>
          <div className='flex flex-col justify-center gap-8 md:gap-3 w-full'>
            <EstimatedPrices sale={sale} valuation={valuation} setValuation={setValuation} />
            {valuation && <PotentialBuyers sale={sale} valuation={valuation} />}
          </div>

          <div className='md:w-2/3'>
            <ExpertMeeting sale={sale} />
          </div>
        </div>
      }

      {sale.selling &&
        <HiddenPrices valuation={valuation}
                      isFineProperty={isFineProperty}
                      bigDiffWithExpectation={bigDiffWithExpectation}
                      confident={confident} />
      }

      <div className='flex flex-col justify-center gap-12 mt-16'>
        <PriceGraph sale={sale} />

        <SoldProperties sale={sale} />

        <NextSteps />

        <Separator />

        <HosmanPros />

        <TrustpilotReviews expertId={sale.expert?.id} title={<p className='h2 text-ih-indigo text-center'>Hosman, l'agence la plus <span className='text-ih-blue'>recommandée</span></p>} />
      </div>
    </div>
  );
}

export default classicSale;
